import {
	BenefitIcon,
	CompanyIcon,
	CompanyOutlineIcon,
	DebitCardIcon,
	EmployeeIcon,
	EmployeeOutlineIcon,
	ListIcon,
	TopUpIcon,
} from '@shared/assets/icons';
import { Translation } from '@shared/config/i18n';
import { PATHS } from '@shared/constants';

export const companyNavLib = (tT) => [
	{
		to: PATHS.company.COMPANY_PROFILE,
		label: tT(Translation.COMPANY_NAV_COMPANY_PROFILE),
		icon: CompanyOutlineIcon,
		activeIcon: CompanyIcon,
	},

	{
		to: PATHS.company.EMPLOYEES,
		label: tT(Translation.COMPANY_NAV_EMPLOYEES),
		icon: EmployeeOutlineIcon,
		activeIcon: EmployeeIcon,
	},

	{
		to: PATHS.company.DEBITCARDS,
		label: tT(Translation.COMPANY_NAV_DEBIT_CARDS),
		icon: DebitCardIcon,
		activeIcon: DebitCardIcon,
	},

	{
		to: PATHS.company.BENEFITS,
		label: tT(Translation.COMPANY_NAV_BENEFITS),
		icon: BenefitIcon,
		activeIcon: BenefitIcon,
	},

	{
		to: PATHS.company.TOPUPPORDERS,
		label: tT(Translation.COMPANY_NAV_TOPUP_ORDERS),
		icon: TopUpIcon,
		activeIcon: TopUpIcon,
	},
	{
		to: PATHS.company.TOPUPS,
		label: tT(Translation.COMPANY_NAV_TOPUPS),
		icon: ListIcon,
		activeIcon: ListIcon,
	},
];
